<template>
    <div
        class="sticky-banner"
        ref="bannerContainer"
        :class="{ 'sticky-banner__fixed': isFixed }"
        :style=" !isFixed && {'transform': `translateY(-${transalateDistance}px)`}"
    >
        <slot />
    </div>
</template>

<script>
import _throttle from "lodash/throttle";

export default {
    name: "StickyBannerSlide",
    data() {
        return {
            isFixed: false,
            transalateDistance: null
        }
    },
    props: {
        triggerElement: {
            type: String,
            required: true,
        },
        offset: {
            type: Number,
            default: 0
        },
        endElement: {
            type: String
        },
        endElementOffset: {
            type: Number,
            default: 0
        },
    },
    created() {
        document.addEventListener("scroll", this.throttledFunction)
    },
    updated() {
        this.transalateDistance = this.$refs.bannerContainer.offsetHeight;
    },
    beforeDestroy() {
        document.removeEventListener("scroll", this.throttledFunction)
    },
    methods: {
        throttledFunction: _throttle(function() {
            this.stickBanner()
        }, 200),
        stickBanner() {
            const triggerElementTop = document.querySelector(this.triggerElement).getBoundingClientRect().top + this.offset;

            if (!this.endElement) {
                this.isFixed = (triggerElementTop <= 0);
            } else {
                const endElementTop = document.querySelector(this.endElement).getBoundingClientRect().top + this.endElementOffset;
                this.isFixed = (triggerElementTop <= 0 && endElementTop >= 0);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.sticky-banner {
    width: 100%;
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    right: 0;
    transition: all .3s;
    transform: translateY(-120px);
}

.sticky-banner__fixed {
    transform: translateY(0);
}
</style>